import { NextSeo } from 'next-seo'
import { NextPage } from 'next'

import { teacherMentoringProgramSeo } from '@lib/seo'
import FirstFold from '@components/shaastra-upskill-teacher-mentoring-program/first-fold'
import Timeline from '@components/shaastra-upskill-teacher-mentoring-program/timeline'
import SessionRecordings from '@components/shaastra-upskill-teacher-mentoring-program/session-recordings'
import Footer from '@components/common/footer'

const TeacherMentoringProgram: NextPage = () => {
  return (
    <>
      <NextSeo {...teacherMentoringProgramSeo} />
      <FirstFold />
      <Timeline />
      <SessionRecordings />
      <Footer />
    </>
  )
}

export default TeacherMentoringProgram
